import { render } from "./AddMonTemplateView.vue?vue&type=template&id=9c4d4f8a&scoped=true"
import script from "./AddMonTemplateView.vue?vue&type=script&lang=js"
export * from "./AddMonTemplateView.vue?vue&type=script&lang=js"

import "./AddMonTemplateView.vue?vue&type=style&index=0&id=9c4d4f8a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c4d4f8a"]])

export default __exports__